export class ExternalPlatform {
  externalPlatformId: number;
  name: string;
  webServiceUrl: string;
}
